export function ASCIIToDecimal(chars) {
    const arrDecimal = [];
    // Loop trough the chars and build the array
    for (let n = 0, l = chars.length; n < l; n += 1) {
        const dec = Number(chars.charCodeAt(n)).toString(10);
        arrDecimal.push(dec);
    }
    return arrDecimal.join('');
}
